<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div class='d-flex w-100'>
  <p-floatLabel variant="on">
    <well-company-country-dropdown
      id='country'
      (countryChange)='onCountryChange($event)' data-testid="country-dropdown">
    </well-company-country-dropdown>
    <label for='country'>{{ 'legalEntity.country' | translate }}</label>
  </p-floatLabel>

  <bs-autocomplete
    class='ml'
    [ngModel]='selected()'
    (ngModelChange)='selected.set($event)'
    [items]='results'
    [dropdown]='true'
    [disabled]='disabled || !country'
    [placeholder]='placeholder ?? ""'
    [displayWith]='getDisplayName'
    [compareWith]='compareByUuid'
    [inputClass]="'legal-entity-input pe-5'"
    [containerClass]="'border-radius-button'"
    [pTooltip]="(disabled || !country) ? ('legalEntity.selectCountry' | translate) : null"
    tooltipZIndex='10001'
    tooltipPosition='right'
    (queryChange)='onQueryChange($event)'
    (selected)='onSelectItem($event)' data-testid="selected-autocomplete">
    <ng-template bsItem let-company>
      @if (company) {
        <div class='row'>
          <div class='col-12 mb-xs color-gray origin-label uppercase'>
            <span>{{ company.origin }}</span>
          </div>
          <div class='col-12 mb-xs'>
            <h6 class='my-0'>{{ company.companyName }}</h6>
          </div>
          <div class='col-12 mb-xs color-gray registration-code'>
            <span>{{ company.registrationCode | displayNullValue }}</span>
          </div>
        </div>
      }
    </ng-template>

    <ng-template bsFooter>
      @if (showAddButton) {
        <button pButton type='button' class='p-button-text full-width p-3'
                [label]="'legalEntity.noCompanyFound' | translate"
                (click)='addNewCompany()' data-testid="add-new-company-btn">
        </button>
      }
    </ng-template>
  </bs-autocomplete>
</div>

@if (showAddButton) {
  <button pButton type='button' class='p-button-outlined mt'
          [label]="'legalEntity.noCompanyFound' | translate"
          (click)='addNewCompany()' data-testid="add-new-company-btn-2">
  </button>
}

@if (displaySelectedCompany() && selected()?.uuid) {
  <well-legal-entity-card [legalEntity]='selected()' (remove)='deleteSelected()' />
}


